import React from 'react'
import styled from 'styled-components'
import MouseIcon from '@mui/icons-material/Mouse'
import PreviewCard from './PreviewCard'

// --- Styled Components ---

const Mouse_Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
`

const Mouse_EdpiBox = styled.div`
    display: flex;
    flex-direction: column;
`

const Mouse_EdpiValue = styled.div`
    font-size: 32px;
    font-weight: 900;
    font-family: var(--font-chakra);
    color: #6366f1;
    line-height: 1;
    text-shadow: 0 0 15px rgba(99, 102, 241, 0.3);
`

const Mouse_EdpiLabel = styled.div`
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.4);
    margin-top: 6px;
    font-weight: 700;
`

const Mouse_StatsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 8px;
    width: 100%;
`

const Mouse_Stat = styled.div`
    display: flex;
    flex-direction: column;
`

const Mouse_StatVal = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    font-family: var(--font-roboto);
`

const Mouse_StatLab = styled.div`
    font-size: 8px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.3);
    font-weight: 600;
    letter-spacing: 0.8px;
`

const Mouse_BgIcon = styled(MouseIcon)`
    opacity: 0.4;
    font-size: 40px !important;
    color: #6366f1;
`

// --- Main Component ---

export default function MousePreview({
    data,
    isActive,
    isDisabled, // usually !configName
    onToggle,
    onClick,
    t,
    ...props
}) {
    const m = data || {}
    const edpi = Math.round((m.sensitivity || 0) * (m.dpi || 800))
    const txt = (v) => !isDisabled ? v : '-'

    return (
        <PreviewCard
            isActive={isActive}
            isDisabled={isDisabled}
            onClick={onClick}
            onToggle={onToggle}
            label="MOUSE"
            {...props}
        >
            <Mouse_Header>
                <Mouse_EdpiBox>
                    <Mouse_EdpiValue>{txt(edpi)}</Mouse_EdpiValue>
                    <Mouse_EdpiLabel>{t('EFFECTIVE_DPI')}</Mouse_EdpiLabel>
                </Mouse_EdpiBox>
                <Mouse_BgIcon />
            </Mouse_Header>

            <Mouse_StatsGrid>
                <Mouse_Stat>
                    <Mouse_StatVal>{txt(m.sensitivity)}</Mouse_StatVal>
                    <Mouse_StatLab>{t('SENSITIVITY')}</Mouse_StatLab>
                </Mouse_Stat>
                <Mouse_Stat>
                    <Mouse_StatVal>{txt(m.zoom_sensitivity_ratio)}</Mouse_StatVal>
                    <Mouse_StatLab>{t('ZOOM_RATIO')}</Mouse_StatLab>
                </Mouse_Stat>
                <Mouse_Stat>
                    <Mouse_StatVal>{txt(m.dpi)}</Mouse_StatVal>
                    <Mouse_StatLab>{t('BASE_DPI')}</Mouse_StatLab>
                </Mouse_Stat>
                <Mouse_Stat>
                    <Mouse_StatVal>{!isDisabled ? (m.cl_crosshair_sniper_width || '1') + 'px' : '-'}</Mouse_StatVal>
                    <Mouse_StatLab>{t('SNIPER_WIDTH')}</Mouse_StatLab>
                </Mouse_Stat>
            </Mouse_StatsGrid>
        </PreviewCard>
    )
}
